import React, {useEffect, useRef, useState} from 'react';
import {FormGroup, Grid, Switch, Typography} from "@mui/material";
import PropTypes from "prop-types";
import CustomRow from "../typescript/custom-row/custom-row";
import {AuthService} from "../typescript/auth/auth.service";
import {DateUtil} from "../typescript/util/date-util";
import SelectOption from "../typescript/select-option/select-option";
import CustomTextField from "../typescript/custom-text-field/custom-text-field";
import ForeignKey from "../typescript/foreign-key/foreign-key";
import {BusinessSegmentService} from "../typescript/business-segment/business-segment.service";

const DocumentListForm = ({toReceive, setToReceive, byPayment, setByPayment, year, setYear, month, setMonth,
                           businessSegment, setBusinessSegment, observacao, setObservacao}) => {
    const isMaster = AuthService.userInRole("MASTER");
    const anoOptions = DateUtil.startYears();
    const mesOptions = DateUtil.startMonths();

    const [inputValue, setInputValue] = useState(observacao ?? '');
    const debounceRef = useRef(undefined);
    const DEBOUNCE_DELAY = 500;

    useEffect(() => {
        return () => {
            if (debounceRef.current) {
                clearTimeout(debounceRef.current);
            }
        };
    }, []);

    useEffect(() => {
        setInputValue(observacao ?? '');
    }, [observacao]);

    const onChangeObservacao = (event) => {
        const value = event.target.value;
        setInputValue(value);
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
        debounceRef.current = setTimeout(() => {
            setObservacao(value || null);
        }, DEBOUNCE_DELAY);
    };

    const renderSwitchAReceber = () => {
        return isMaster && (
            <FormGroup>
                <Typography component="div">
                    <Grid component="label" container alignItems="center" spacing={1}>
                        <Grid item>À pagar</Grid>
                        <Grid item>
                            <Switch color="primary" checked={toReceive}
                                    onChange={(event) => setToReceive(event.target.checked)}/>
                        </Grid>
                        <Grid item>À receber</Grid>
                    </Grid>
                </Typography>
            </FormGroup>
        )
    }

    const renderSwitchPorPagamento = () => {
        return (
            <FormGroup>
                <Typography component="div">
                    <Grid component="label" container alignItems="center" spacing={1}>
                        <Grid item>Por vencimento</Grid>
                        <Grid item>
                            <Switch color="primary" checked={byPayment}
                                    onChange={(event) => setByPayment(event.target.checked)}/>
                        </Grid>
                        <Grid item>Por pagamento</Grid>
                    </Grid>
                </Typography>
            </FormGroup>
        )
    }

    const onChangeBusinessSegment = (value) => {
        const id = !value || value === '' ? null : Number(value);
        setBusinessSegment(id ? {id} : null);
    };

    const onSelectBusinessSegment = (item) => {
        setBusinessSegment(item ?? null);
    };

    return (
        <React.Fragment>
            <CustomRow>
                {renderSwitchAReceber()}
                {renderSwitchPorPagamento()}
            </CustomRow>
            <CustomRow>
                <SelectOption fullWidth required label="Ano" value={year}
                              onChange={(event) => setYear(event.target.value)} items={anoOptions} itemValue='name'
                              itemDescription='description'/>
                <SelectOption fullWidth required label="Mês" value={month}
                              onChange={(event) => setMonth(event.target.value)} items={mesOptions} itemValue='name'
                              itemDescription='description'/>
            </CustomRow>
            <CustomRow>
                <ForeignKey fullWidth label="Segmento de negócio" value={businessSegment} fieldKey={'id'}
                            fieldDescription={'description'} labelDescription='Descrição'
                            onChange={onChangeBusinessSegment} onSelect={onSelectBusinessSegment}
                            findAll={BusinessSegmentService.findAll}
                            dataColumnNames={['ID', 'Descrição']} dataColumns={['id', 'description']}
                            dataTypes={['number', 'text']}/>
                <CustomTextField fullWidth label="Observação" value={inputValue}
                                 onChange={onChangeObservacao}/>
            </CustomRow>
        </React.Fragment>
    )

}

DocumentListForm.propTypes = {
    toReceive: PropTypes.bool.isRequired,
    setToReceive: PropTypes.func.isRequired,
    byPayment: PropTypes.bool.isRequired,
    setByPayment: PropTypes.func.isRequired,
    year: PropTypes.number.isRequired,
    setYear: PropTypes.func.isRequired,
    month: PropTypes.number.isRequired,
    setMonth: PropTypes.func.isRequired,
    businessSegment: PropTypes.object,
    setBusinessSegment: PropTypes.func,
    observacao: PropTypes.string,
    setObservacao: PropTypes.func
};

export default React.memo(DocumentListForm);